import { State } from '../reducers';
import { createSelector } from '@ngrx/store';
import { HierarchyHelper } from 'src/app/itemtypes/hierarchy-helper';
import { InventoryAggregateHelper } from 'src/app/inventory/inventory-aggregate-helper';

const hierarchyHelper = new HierarchyHelper();
const aggregateHelper = new InventoryAggregateHelper();

export const selectInventoryFeature = (state: State) => state.inventory;
export const selectLoaded = createSelector(selectInventoryFeature, (state) => state.typesLoaded);

/**
 * select basic types as list
 */
export const selectTypes = createSelector(selectInventoryFeature, (state) => state.types);

/**
 * select hierarchical types
 */
export const selectHierarchicalTypes = createSelector(selectTypes, (types) =>
  hierarchyHelper.typeListToHierarchy(types)
);

/**
 * select types in tree form
 */
export const selectTypesAsTree = createSelector(selectHierarchicalTypes, (types) =>
  hierarchyHelper.typesAsTree(types)
);

export const selectApplications = createSelector(
  selectInventoryFeature,
  (state) => state.applications
);

export const selectRecords = createSelector(selectInventoryFeature, (state) => state.records);

export const selectInventoryOverview = createSelector(
  selectRecords,
  selectHierarchicalTypes,
  selectApplications,
  (recs, types, apps) => aggregateHelper.buildOverview(types, apps, recs)
);

// Type list - highlighted types - where incoming (purchase) exits
export const selectHightlightTypes = createSelector(selectInventoryOverview, (types) =>
  types.filter((tp) => tp.in && tp.in > 0)
);

// Type list - those types that are used somewhere
export const selectHightlightUsedTypes = createSelector(selectInventoryOverview, (types) =>
  types.filter((tp) => tp.out && tp.out > 0)
);

// Type of parent type
// TODO : implement this
// ... with arguments (parent type(s)
export const selectChildTypes = createSelector(selectInventoryOverview, (types) =>
  types.filter((tp) => tp.out && tp.out > 0)
);
